import { render, staticRenderFns } from "./TestimonialV2.vue?vue&type=template&id=0d65a6bb&scoped=true&"
import script from "./TestimonialV2.vue?vue&type=script&lang=ts&"
export * from "./TestimonialV2.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialV2.vue?vue&type=style&index=0&id=0d65a6bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65a6bb",
  null
  
)

export default component.exports